module.exports = __webpack_public_path__ + "018c5fc241ef6f39dbcb9d854c3e96c3.pdf";